export const Faq = () => (
  <div className="faq tnm-v1">
    <main className="main">
      <section className="page-hero">
        <div className="page-header">
          <div className="container">
            <h1>
              Frequently <span>Asked Questions</span>
            </h1>
          </div>
        </div>
      </section>
      <section className="faqs">
        <div className="container">
          <div className="question-answer">
            <h3>Can I order individual meals?</h3>
            <p>
              We believe that a healthy, nutritional diet doesn't happen
              overnight. The Nutritionist MCR is your day-to-day nutritional
              companion, so we only offer our fresh meals as part of a
              subscription service. If you would like to add extra meals to your
              plan, that's no problem; we can just add them to your
              subscription.
            </p>
          </div>
          <div className="question-answer">
            <h3>How can I pay for my subscription?</h3>
            <p>
              The easiest way to pay for your subscription is via Direct Debit
              which is taken on or around the 1st of every month. We also accept
              payment via BACS or Paypal.
            </p>
          </div>
          <div className="question-answer">
            <h3>How often do you deliver?</h3>
            <p>
              To guarantee freshness, your meals are split into two weekly
              deliveries of meals that last you for three days each. All of our
              fresh meals are cooked to be enjoyed within three days of
              delivery, which is why we don't provide meals for Sunday.
            </p>
          </div>
          <div className="question-answer">
            <h3>What if I’m not in to receive my meals?</h3>
            <p>
              Don’t worry! Your meals will be delivered in a thermal cool bag
              which will keep your meals at a safe temperature all day. We’re
              happy to leave your meals in a safe place e.g. with a concierge.
            </p>
          </div>
          <div className="question-answer">
            <h3>What if I go on holiday?</h3>
            <p>
              You can pause your plan for as long as you like, whenever you
              like. Just remember to provide us with a minimum of one week's
              notice, as we order our fresh ingredients one week in advance. If
              we've already taken your subscription payment for the month, we'll
              credit you your pause duration amount in the following month.
            </p>

            <p>
              Please send your pause request to{' '}
              <a href="mailto:pauseme@Thenutritionistmcr.com">
                Pauseme@Thenutritionistmcr.com
              </a>{' '}
              specifying the dates you want to pause between.
            </p>
          </div>
          <div className="question-answer">
            <h3>Can the meals be frozen?</h3>
            <p>
              Yes, most of the freshly prepared meals are suitable for home
              freezing; we recommend defrosting them in the fridge for 24 hours
              prior to heating and they’ll taste as good as when they were
              delivered. Some meals such as salads don’t freeze well; look out
              for a sticker on these boxes.
            </p>
          </div>
          <div className="question-answer">
            <h3>What if there’s something I don’t like?</h3>
            <p>
              We can’t amend individual ingredients in the dishes but you can
              choose to swap out whole dishes in your weekly delivery. We’ll
              send you a weekly menu in advance so you have a chance to select
              which meals you would like instead.
            </p>
          </div>
          <div className="question-answer">
            <h3>Can I choose my meals?</h3>
            <p>
              We have a wide repertoire of healthy, delicious meals. Each week
              we’ll send you a menu of meals for the following week. If you’d
              like to tailor the menu to include more of the meals you love from
              that menu that’s no problem just let us know by the Wednesday
              before for the following week's delivery.
            </p>
          </div>
          <div className="question-answer">
            <h3>Is there a minimum term to my subscription?</h3>
            <p>
              The minimum subscription term is one month. If you decide to
              cancel your plan we ask for one month’s notice{' '}
            </p>
          </div>
          <div className="question-answer">
            <h3>What if my fitness &amp; nutrition goals change?</h3>
            <p>
              We understand. Get in touch with one of the team, we’ll discuss
              your new goals and help you find the plan that’s right for you.
              You can easily switch your plan, we just need to know seven days
              before the end of your current plan month.
            </p>
          </div>
          <div className="question-answer">
            <h3>
              I have a food allergy, can The Nutritionist Mcr provide meals for
              me?
            </h3>
            <p>
              As our meals are freshly prepared in one kitchen, we cannot
              guarantee that the meals won’t contain traces of certain allergens
              so currently we aren’t able to cater for those with allergies. If
              you’re unsure, please get in touch with one of our expert team who
              will be happy to advise.
            </p>
          </div>
          <div className="question-answer">
            <h3>Do the menus change often?</h3>
            <p>
              Yes. We’re continuously developing our meals. As our ingredients
              are always fresh, the menus change with the seasons. Expect some
              delicious salads and cold food for the hot summer days and
              warming, hearty meals during those cold winter months. Always
              nutritionally balanced, of course!
            </p>
          </div>
        </div>
      </section>{' '}
    </main>
  </div>
);
